<template>
  <div :class="['radio-group', ...classList]">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface ViewProps {
  direction?: 'row' | 'column';
}

const props = withDefaults(defineProps<ViewProps>(), {
  direction: 'row',
});

const classList = computed(() => [`direction-${props.direction}`]);
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.radio-group {
  display: grid;
  gap: var(--t-spacing-md);

  &.direction-row {
    grid-template-columns: 1fr 1fr;
  }

  &.direction-column {
    grid-template-rows: repeat(auto-fill, minmax(0, 1fr));
  }

  @include mobile {
    grid-template-columns: 1fr !important;
    grid-template-rows: 1fr 1fr;
  }
}
</style>
